import React from "react";
import { Link, useLocation } from "react-router-dom";
import FooterTerms from "./components/FooterTerms";
import FooterPrivacy from "./components/FooterPrivacy";
export default function MainFooter() {
  const location = useLocation();
  return (
    <>
      {" "}
      <footer className="main-footer">
        <p style={{ color: "white", fontWeight: "semi-bold" }}>
          © 2023 Harong Bikolnon Creatives
        </p>
        <div style={{ display: "flex", gap: "20px" }}>
          <p>
            <Link to="/terms">Terms of Service</Link>
          </p>
          <p>
            <Link to="/privacy">Privacy Policy</Link>
          </p>
        </div>
      </footer>
      {location.pathname === "/terms" && <FooterTerms />}
      {location.pathname === "/privacy" && <FooterPrivacy />}
    </>
  );
}
